<template>
  <!-- Counter -->
  <section class="property-counter">
    <div class="property-counter-float-bg">
      <img src="@/assets/img/bg/counter-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <div class="property-counter-list text-center">
            <h4 class="counterUp">66,180</h4>
            <p>HOMES FOR SALE</p>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="property-counter-list text-center">
            <h4 class="counterUp">4,809</h4>
            <p>OPEN HOUSES</p>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="property-counter-list text-center">
            <h4 class="counterUp">30,469</h4>
            <p>RECENTLY SOLD</p>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="property-counter-list text-center">
            <h4 class="counterUp">2,919</h4>
            <p>PRICE REDUCED</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Counter -->
  <!-- Recent Properties for Rent -->
  <section class="property-for-rent common-padding">
    <div class="footer-six-bg footer-nine-bg">
      <img src="@/assets/img/bg/feature-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-3"></div>
          <div
            class="col-md-6 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Recent Properties for Rent</h2>
            <p>Sense Solutions For All Aspects near your Location.</p>
          </div>
          <div
            class="col-md-3 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          >
            <router-link to="categories" class="btn btn-view"
              >View all Properties</router-link
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="car-class-carousel">
            <div
              class="top-listings-rent-slider owl-carousel"
              data-aos="fade-right"
            >
              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in IndexNineCounter" :key="item.id">
                  <div class="top-rent-room">
                    <div class="top-room-img">
                      <router-link to="categories"
                        ><img
                          :src="require(`@/assets/img/gallery/${item.image}`)"
                          class="img-fluid"
                          alt=""
                      /></router-link>
                    </div>
                    <div class="top-listing-rounded-img">
                      <div class="favourite-small-user">
                        <img
                          :src="require(`@/assets/img/profiles/${item.avatar}`)"
                          class="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="pent-house">
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="top-rent-room-info">
                      <div class="top-rent-room-location">
                        <div class="room-address">
                          <span
                            ><i class="fa-solid fa-location-dot"></i
                            >{{ item.place }}</span
                          >
                          <router-link to="categories"
                            ><h5>{{ item.text }}</h5></router-link
                          >
                        </div>
                        <div class="star-rated">
                          <span
                            ><i class="fa-solid fa-star"></i>
                            <i class="fa-solid fa-star"></i>
                            <i class="fa-solid fa-star"></i>
                            <i class="fa-solid fa-star"></i>
                            <i class="fa-solid fa-star"></i
                          ></span>
                          <p>
                            <span>{{ item.price }} </span>Per day
                          </p>
                        </div>
                      </div>
                      <div class="top-room-details">
                        <div class="area">
                          <span
                            ><img
                              src="@/assets/img/icons/area-icon.svg"
                              class="img-fluid"
                              alt=""
                            />Area:{{ item.area }}</span
                          >
                        </div>
                        <div class="area">
                          <span
                            ><img
                              src="@/assets/img/icons/bed-icon.svg"
                              class="img-fluid"
                              alt=""
                            />Beds:{{ item.beds }}</span
                          >
                        </div>
                        <div class="area">
                          <span
                            ><img
                              src="@/assets/img/icons/bath-icon.svg"
                              class="img-fluid"
                              alt=""
                            />Baths:{{ item.baths }}</span
                          >
                        </div>
                        <div class="area">
                          <span
                            ><img
                              src="@/assets/img/icons/floor-icon.svg"
                              class="img-fluid"
                              alt=""
                            />Floors:{{ item.floors }}</span
                          >
                        </div>
                        <div class="area">
                          <span
                            ><img
                              src="@/assets/img/icons/guest-icon.svg"
                              class="img-fluid"
                              alt=""
                            />Guest:{{ item.guest }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </Slide>
                <template #addons>
                  <Pagination />
                </template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Recent Properties for Rent -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexNineCounter from "@/assets/json/indexNineCounter.json";
export default {
  data() {
    return {
      IndexNineCounter: IndexNineCounter,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1000: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mouted() {},
};
</script>
